import { TelegramAuthResponseDto } from "definitions/poizon-sso";
import { useEffect, useRef, useState } from "react";

export interface TelegramInjectProps {
  botUsername: string;
  size?: "small" | "medium" | "large";
  userImage?: boolean;
  radius?: number;
  onTelegramAuth?: typeof window.onTelegramAuth;
  onLogout?: () => void;
  redirectUrl?: string;
  requestAccess?: boolean;

  user?: TelegramAuthResponseDto | null;
}

export const useTelegramInject = ({
  botUsername,
  size = "medium",
  userImage = true,
  radius,
  onTelegramAuth,
  redirectUrl,
  requestAccess,
  user,
}: TelegramInjectProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(true);

  /* eslint-disable react-you-might-not-need-an-effect/no-adjust-state-on-prop-change -- императивная инъекция telegram-widget <script> в DOM; isLoading выставляется после side-effect */
  useEffect(() => {
    if (user) {
      containerRef!.current?.childNodes.forEach((node) => {
        if (node.nodeName === "IFRAME")
          containerRef!.current?.removeChild(node);
      });
      return setIsLoading(false);
    }

    const button = document.createElement("script");

    button.async = true;
    button.src = "https://telegram.org/js/telegram-widget.js?22";

    button.setAttribute("data-telegram-login", botUsername);
    button.setAttribute("data-size", size);
    button.setAttribute("data-userpic", String(userImage));

    if (radius) {
      button.setAttribute("data-radius", String(radius));
    }

    if (requestAccess) {
      button.setAttribute("data-request-access", "write");
    }

    if (redirectUrl) {
      button.setAttribute("data-auth-url", redirectUrl);
    }

    if (onTelegramAuth) {
      button.setAttribute("data-onauth", "onTelegramAuth(user)");

      window.onTelegramAuth = onTelegramAuth;
    }

    containerRef!.current?.appendChild(button);
    setIsLoading(false);

    return () => {
      containerRef!.current?.removeChild(button);
    };
  }, [
    botUsername,
    size,
    userImage,
    radius,
    onTelegramAuth,
    redirectUrl,
    requestAccess,
    user,
  ]);
  /* eslint-enable react-you-might-not-need-an-effect/no-adjust-state-on-prop-change */

  return { ref: containerRef, isLoading };
};
